module.exports = __webpack_public_path__ + "static/img/star.313f08eb.png";